<template>
  <div>
    <div id="firebaseui-auth-container"></div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import '../../node_modules/firebaseui/dist/firebaseui.css';
import { auth } from '../firebase';
import { router } from '../router';
import { UserModule } from '@/store/modules/user';

export default {
	props: ['inviteCode'],
		
  mounted() {

		document.title = 'mixlet: Login';
	
    if (UserModule.userProfile) {
       $router.push('/');
       return;
		} 

		let self = this;
		console.log('inviteCode in outer', self.$route.query.inviteCode)
    function processSignInSuccess(authResult, redirectUrl) {
			console.log('inviteCode in success', self.$route.query.inviteCode)
			self.$store.dispatch('setCurrentUser', {currentUser: authResult.user, inviteCode: self.$route.query.inviteCode});
			if (self.$route.query.redir) {
        UserModule.setLoginRedirect(self.$route.query.redir)
      } else {
        UserModule.setLoginRedirect('/');
      }
    }

    let uiConfig = {
      // signInFlow: 'popup',
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID
        },
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false
        }
      ],
      callbacks: {
        signInSuccessWithAuthResult: processSignInSuccess
      }
    };
    var ui =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    ui.start('#firebaseui-auth-container', uiConfig);
  }
};
</script>